import { Routes } from '@angular/router';
import { MonitoringCenterComponent } from './monitoring-center.component';
import { RideDetailsComponent } from './pages/ride-details/ride-details.component';
import { RidesListComponent } from './pages/rides-list/rides-list.component';
import { InternalGuard } from '../../core/auth/guards/auth.guard';
import { firebaseInitializerResolver } from '../../shared/services/firebase-initializer.resolver';
import { googlemapsInitializerResolver } from '../../shared/services/googlemaps-initializer.resolver';

export const MonitoringCenterRoutes: Routes = [
  {
    path: 'monitoring-center',
    component: MonitoringCenterComponent,
    canActivate: [InternalGuard],
    resolve: {
      firebaseInitialized: firebaseInitializerResolver,
      googleMapsInitialized: googlemapsInitializerResolver,
    },
    children: [
      {
        path: '',
        redirectTo: 'rides',
        pathMatch: 'full',
      },
      {
        path: 'rides',
        component: RidesListComponent,
      },
      {
        path: 'ride-details/:id',
        component: RideDetailsComponent,
      },
    ],
  },
];
